import React from 'react';

const StanchezzaIcon = ({ primaryColor, secondaryColor, width }) => {
  const strokePrimary = primaryColor || '#282828';
  const strokeSecondary = secondaryColor || '#ffcf38';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Livello_2"
      data-name="Livello 2"
      viewBox="0 0 200 200"
      style={{ width }}
    >
      <defs>
        <style>
          {`.cls-1,.cls-2{stroke:${strokeSecondary};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.cls-2{stroke:${strokePrimary}}`}
        </style>
      </defs>
      <path
        d="M85.69 52c-3.05 3.79-3.86 11.01-2.19 15.59 1.66 4.58 4.72 8.49 7.45 12.52 2.73 4.03 5.23 8.48 5.53 13.35.44 7.16-4.63 14.29-11.5 16.17-6.73 1.84-14.5-.86-20.55 2.63-4.57 2.64-6.79 8.27-6.8 13.58-.02 5.31 1.34 9.16 3.13 14.16M141.07 96.51c2.61-10.44 1.78-21.35-6.94-28.51-3.85-3.16-8.94-5.09-13.86-5.5-3.9-.32-7.58.75-11.02 2.55-2.97 1.56-5.57 4.25-9.19 3.66-3.13-.51-5.66-3.71-6.46-6.69-.83-3.09.77-7.57 2.79-10.03"
        className="cls-2"
      />
      <path
        d="M73.23 140c-1.16-2.07-2.55-4.49-3.19-6.78-.83-2.99-.8-6.93 1.9-8.97 1.59-1.21 3.83-1.49 5.67-.71 1.61.68 2.83 2.05 3.98 3.37 2.76 3.17 5.86 5.95 9.76 7.62 4.83 2.07 10.24 2.31 15.4 1.19"
        className="cls-2"
      />
      <path
        d="M142.37 118.81c0 9.9-8.03 17.93-17.93 17.93-5.86 0-11.45-2.94-14.77-7.76-4.07-5.9-3.31-13.14-.62-19.48 3.31-7.81 8.27-14.94 10.6-23.1 6.42 6.34 9.68 12.86 11.31 21.01 1.26-3.23 2.4-6.53 2.34-10 5.31 5.49 9.07 13.77 9.07 21.41Z"
        className="cls-1"
      />
      <path
        d="M117.87 132.74c-.83-2.21-.52-4.7.24-6.94s1.94-4.3 2.87-6.47 1.62-4.53 1.32-6.87c2.92 1.35 5.28 3.77 6.84 6.58 1.56 2.81 2.36 6.01 2.62 9.22.17 2.09.05 4.38-1.26 6.01-3.06 3.79-10.86 3.18-12.64-1.53Z"
        className="cls-1"
      />
    </svg>
  );
};

export default StanchezzaIcon;
